import { Typography } from 'antd';

function Ellipsis({ text }: { text: string }) {
  return (
    <Typography.Paragraph
      ellipsis={{ rows: 3 }}
      style={{ maxWidth: '40em' }}
    >
      {text}
    </Typography.Paragraph>
  );
}

export default Ellipsis;